module.exports = __webpack_public_path__ + "static/media/blog-42-2.b37ef6e7.webp";